export default Object.freeze({
  reportLinks: {},
});
